module.exports = __webpack_public_path__ + "img/case25-jpg.62466ed4.jpg";